export default [
  {
    path: '/users',
    component: () => import('../../views/users/users.vue'),
    meta: {
      pageTitle: 'Users',
      breadcrumbs: ['Users'],
    },
    children: [
      {
        path: '',
        name: 'users-list',
        component: () => import('../../views/users/list.vue')
      },
      {
        path: ':id',
        name: 'users-edit',
        component: () => import('../../views/users/edit.vue'),
        meta: {
          pageTitle: 'Edit User',
          breadcrumbs: ['Users', 'Edit'],
        }
      },
    ]
  }
]
